
import { formatPrice } from '@artmizu/utils';
import ToggleSwitch from '~/components/WriteOffBonuses/ToggleSwitch.vue';
const __sfc_main = {};
__sfc_main.props = {
  allowToSpend: {
    key: "allowToSpend",
    required: true,
    type: Number
  },
  balance: {
    key: "balance",
    required: true,
    type: Number
  },
  modelValue: {
    key: "modelValue",
    required: false,
    type: Boolean
  },
  disabled: {
    key: "disabled",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  return {
    formatPrice,
    emit
  };
};
__sfc_main.components = Object.assign({
  ToggleSwitch
}, __sfc_main.components);
export default __sfc_main;
